import styled from 'styled-components'
import { useTransition, animated, config } from '@react-spring/web'
import { device } from '../breakpoints'

export const SourceArticles = ({ articles }: { articles: any }) => {
  const articlesTransitions = useTransition(
    articles.size > 0 ? [...articles.values()] : [],
    {
      keys: (item) => (item ? item.id : ''),
      from: { opacity: 0, maxHeight: 0 },
      enter: { opacity: 1, maxHeight: 200 },
      leave: { opacity: 0, maxHeight: 0 },
      update: { maxHeight: 200 },
      config: config.stiff,
      trail: 300,
    }
  )

  return (
    <Container>
    <SegmentTitle>Sources:</SegmentTitle>
    <ArticlesContainer>
    <Articles>
      {articlesTransitions((style, item) => (
        <Article href={item.url} target="_blank" style={style}>
          <Content>
            <ImageContainer
              style={{ backgroundImage: `url(${item.imageSrc})` }}
            />
            <Text>
              <TitleHeader>
                {item.isPremium ? <Abo /> : ''}
                {item.titleHeader}{' '}
              </TitleHeader>
              <Title>{item.title}</Title>
            </Text>
          </Content>
        </Article>
      ))}
    </Articles>
    </ArticlesContainer>
    </Container>
  )
}

const Container = styled.div`
margin-top: 3rem;
position: relative;
`

const SegmentTitle = styled.div`
  font-size: 1.25rem;
  text-transform: uppercase;
  font-weight: 700;
`

const Article = styled(animated.a)`
  text-decoration: none;
  color: var(--text-color);
  display: block;
  flex: 0 0 auto;
  width: 100%;
  white-space: normal;
  margin-right: 1rem;
  border-right: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colorGrey};
  padding-bottom: 1rem;
  margin-bottom: 1rem;

  &:last-child {
    border: 0;
    padding-bottom: 0;
    margin-bottom: 0;
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    width: 250px;
    border-right: 1px solid ${({ theme }) => theme.colorGrey};
    border-bottom: 0;
    padding-bottom: 0;
    margin-bottom: 0;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    width: 100%;
    border-right: 0;
    border-bottom: 1px solid ${({ theme }) => theme.colorGrey};
    padding-bottom: 1rem;
    margin-bottom: 1rem;
  }
`

const ArticlesContainer = styled.div`
height: 100%;
position: relative;

&:after {
  pointer-events: none;
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 20%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(${({ theme }) => theme.colorMode === 'dark' ? '18, 18, 18' : '255, 255, 255'}, 0),
    rgba(${({ theme }) => theme.colorMode === 'dark' ? '18, 18, 18' : '255, 255, 255'}, 1) 100%
  );
}
`

const Articles = styled.div`
  background: ${({ theme }) => theme.colorSiteBackground};
  border: 1px solid ${({ theme }) => theme.colorGrey};
  padding: 2rem;
  display: flex;
  flex-direction: column;
  overflow-x: scroll;
  white-space: nowrap;
  position: relative;
  box-sizing: border-box;
  width: 100%;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    flex-direction: row;
    width: calc(100vw - 4rem);
  }

  @media ${device.tablet}, @media ${device.laptop} {
    flex-direction: column;
    width: 100%;
  }
`

const TitleHeader = styled.div`
  font-size: 1.25rem;
  line-height: 1.2;
  margin-bottom: 0.5rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: none;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    max-width: 150px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    max-width: none;
  }
`

const Content = styled.div`
  display: flex;
`

const Title = styled.div`
  font-size: 1.45rem;
  line-height: 1.2;
`

const Text = styled.div`
  margin-left: 1rem;
`

const ImageContainer = styled.div`
  width: 50px;
  height: 50px;
  background-size: cover;
  background-position: center;
  flex-shrink: 0;
`

const Abo = styled.div`
  display: inline-block;
  margin-right: 0.5rem;
  -webkit-font-smoothing: antialiased;

  &::after {
    display: block;
    content: 'Abo';
    font-size: 1rem;
    padding: 0.2rem 0.5rem 0.15rem 0.5rem;
    text-align: center;
    position: relative;
    color: ${({ theme }) => theme.colorTextInverted};
    background-color: ${({ theme }) => theme.colorText};
  }
`
